// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__8kV8Q","filters_close":"FiltersBlock_filters_close__my51K"};